import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useActivateEmployerMutation = () => {
  const { mutateAsync } = useMutation((organizationId: string) =>
    api.patch(API_URL.ORGANIZATIONS_ACTIVATE_BY_ORGANIZATION_ID(organizationId))
  );
  return {
    activateEmployerAsync: mutateAsync,
  };
};
